export enum ColumnPlacementType {
  PARAM = "PARAM",
  ARRAY = "ARRAY",
  DIVISION = "DIVISION",
  MAX_DISTANCE = "MAX_DISTANCE",
}
export enum ColumnHorizontalAlignment {
  RIGHT = "RIGHT",
  CENTER = "CENTER",
  LEFT = "LEFT",
}

export enum ColumnLateralAlignment {
  CENTER = "CENTER",
  FRONT = "FRONT",
  BACK = "BACK",
}
export enum StructuralColumnMaterial {
  WOOD = "WOOD",
}

export enum StructuralColumnBuilt {
  POST = "POST",
}

export enum ColumnSubType {
  ARCHITECTURAL = "ARCHITECTURAL",
  STRUCTURAL = "STRUCTURAL",
}
